module.exports = __webpack_public_path__ + "img/a2_sidebar2.918e89e7.png";